<template>
  <div class="all-wrapper with-side-panel solid-bg-all">
     <div class="layout-w">
       <app-sidebar></app-sidebar>
       <div class="content-w">
         <app-navbar></app-navbar>
         <div class="content-i">
           <div class="content-box">

            <h1>ZERO ONE by Dreamstart (PT. Transaksi Aman Bersama / Dreamstart Global LLC)</h1>
    <p>These Terms and Conditions ("Terms") govern your use of the ZERO ONE gaming platform ("Platform"), which offers game server hosting for CS2 ("Game"), a game owned by Valve Corporation ("Valve"). By accessing or using our Platform, including any services, features, or functionality offered on or through our Platform, you agree to be bound by these Terms. If you do not agree to these Terms, do not access or use the Platform.</p>
    
    <h2>1. User Account and Data</h2>
    <ul>
        <li><strong>Account Creation:</strong> To use certain features of the Platform, you may need to create an account using your Steam account provided by Valve. By linking your Steam account, you authorize us to access certain information associated with your Steam account.</li>
        <li><strong>User Consent:</strong> Logging in with Steam means you consent to ZERO ONE accessing your gaming data, including, but not limited to, your public profile, friends list, and game details.</li>
        <li><strong>Data Security:</strong> ZERO ONE does not store user credentials or sensitive account information. We employ measures to protect the data we access, but we are not liable for any unauthorized access to or leaks of your data.</li>
    </ul>
    
    <h2>2. Subscription Services</h2>
    <ul>
        <li><strong>Premium Subscription:</strong> ZERO ONE offers a Premium subscription that provides enhanced features and services for the Game. Details about the subscription, including benefits and fees, are available on our Platform.</li>
        <li><strong>No Refunds Policy:</strong> All payments made to ZERO ONE, including for the Premium subscription, are final and non-refundable.</li>
        <li><strong>Automatic Renewal:</strong> The Premium subscription is automatically renewed at the end of each subscription period, unless you cancel it prior to the renewal date.</li>
    </ul>
    
    <h2>3. Limitation of Liability</h2>
    <p>ZERO ONE is not responsible for any loss or damage arising from unauthorized access to your account, data leaks, or loss of data. We disclaim all liability in the event of any service interruption, data loss, or breach of data security related to your use of the Platform.</p>
    
    <h2>4. User Conduct</h2>
    <p>You agree not to misuse the Platform or help anyone else do so. You are responsible for all your activity in connection with the services.</p>
    
    <h2>5. Amendments to Terms</h2>
    <p>We reserve the right to modify these Terms at any time. We will notify users of any changes by posting the new Terms on the Platform. Your continued use of the Platform after any such changes take effect constitutes your acceptance of the new Terms.</p>
    
    <h2>6. Governing Law</h2>
    <p>These Terms shall be governed by the laws of the jurisdiction in which ZERO ONE operates, without regard to its conflict of law provisions.</p>
    
    <h2>Acceptance</h2>
    <p>By using the ZERO ONE Platform, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.</p>

             <app-darkcolor></app-darkcolor>
             <app-invitation v-if="this.$root.isAuthenticated"></app-invitation>
           </div>
           <app-rightsidebar></app-rightsidebar>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
import Navbar from './partials/Navbar.vue';
import Sidebar from './partials/Sidebar.vue';
import RightSidebar from './partials/RightSidebar';
import Invitation from './partials/Invitation';
import Alert from './partials/Alert';
import Moment from 'moment';

export default {
  name: 'Home',
  metaInfo: {
    title: 'home',
    titleTemplate: 'zero1 by Dreamstart | %s',
    meta: [
      { property: 'og:title', content: 'zero1 by Dreamstart | home' },
      { property: 'og:site_name', content: 'zero1' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://zero1.gg/'},
      { property: 'og:description', content: 'Providing public & private CS:GO servers' },
      { itemprop: 'name', content: 'zero1 by Dreamstart | home' },
      { itemprop: 'description', content: 'Providing public & private CS:GO servers'},
    ]
  },
  data() {
    return {
      welcomeText: 'Welcome to zero1!',
      servers: [],
      matches: [],
      errors: ["test"],
      rank: 'F',
      multi1v1_profile: {}
    }
  },
  computed: {
    //
  },
  methods: {
    getServers() {
      this.axios.get(`${this.API_URL}/api/v1/servers`).then((res) => {
        res.data.find((s, v) => {
          s.steam_url = `steam://connect/${s.full_address}`;
          this.servers.push(s);
        });
      });
    },
    getMulti1v1Player() {
      this.axios.get(`${this.API_URL}/apollo/stats/multi1v1/${this.$root.userProfile.id}`).then((res) => {
        this.multi1v1_profile = res.data;
      });
    },
    getMatches() {
      this.axios.get(`${this.API_URL}/apollo/matches`).then((res) => {
        this.matches = res.data;
      });
    },
    pay(package_name, method) {
      this.axios.post(`${this.API_URL}/invoices/create`, { type: package_name, method: method }).then((res) => {
        if (method === 'xendit') {
          window.location.href = res.data.invoice_url;
        } else if (method === 'coowry') {
          this.errors.push('Please check your mobile phone for SMS!');
        }
      }).catch((err) => {
        this.errors = [];
        this.errors.push(err.response.data.message);
      });
    },
    connectDiscord() {
      this.axios.get(`https://discord.gg/mtwt4Ay`).then((res) => {
        window.location.href = res.data.url;
      });
    },
    getReadableDays(date) {
      return Moment(date).fromNow();
    },
    detectMob() {
     if( navigator.userAgent.match(/Android/i)
     || navigator.userAgent.match(/webOS/i)
     || navigator.userAgent.match(/iPhone/i)
     || navigator.userAgent.match(/iPad/i)
     || navigator.userAgent.match(/iPod/i)
     || navigator.userAgent.match(/BlackBerry/i)
     || navigator.userAgent.match(/Windows Phone/i)
     ){
        return true;
      }
     else {
        return false;
      }
    }
  },
  watch: {
    '$root.isAuthenticated': function(isAuthenticated) {
      if (isAuthenticated) {
        this.getMulti1v1Player();
      }
    }
  },
  created() {
    if (this.$route.query && this.$route.query.hasOwnProperty('authToken')) {
      this.$root.authToken = this.$route.query.authToken;
    }

    window.$('body').addClass('before-body menu-position-side menu-side-left full-screen with-content-panel');
    this.getServers();
    if (!this.$root.isAuthenticated) {
      this.getMatches();
    }

    Number.prototype.between = function(a, b) {
      var min = Math.min.apply(Math, [a, b]),
        max = Math.max.apply(Math, [a, b]);
      return this > min && this < max;
    }

    if (this.$root.krakenProfile.level.between(0, 500)) {
      this.rank = 'F'
    } else if (this.$root.krakenProfile.level.between(500, 1000)) {
      this.rank = 'F+'
    } else if (this.$root.krakenProfile.level.between(1000, 1500)) {
      this.rank = 'E'
    } else if (this.$root.krakenProfile.level.between(1500, 2000)) {
      this.rank = 'E+'
    } else if (this.$root.krakenProfile.level.between(2000, 2500)) {
      this.rank = 'D'
    } else if (this.$root.krakenProfile.level.between(2500, 3000)) {
      this.rank = 'D+'
    } else if (this.$root.krakenProfile.level.between(3000, 3500)) {
      this.rank = 'C'
    } else if (this.$root.krakenProfile.level.between(4000, 4500)) {
      this.rank = 'C+'
    } else if (this.$root.krakenProfile.level.between(4000, 4500)) {
      this.rank = 'B'
    } else if (this.$root.krakenProfile.level.between(4500, 5000)) {
      this.rank = 'B+'
    } else if (this.$root.krakenProfile.level.between(5000, 5500)) {
      this.rank = 'A'
    } else if (this.$root.krakenProfile.level.between(5500, 6000)) {
      this.rank = 'A+'
    }

    if (this.$root.isAuthenticated) {
      this.getMulti1v1Player();
    }

  },
  mounted() {
    //
  },
  components: {
    'app-navbar': Navbar,
    'app-sidebar': Sidebar,
    'app-alert': Alert,
    'app-rightsidebar': RightSidebar,
    'app-invitation': Invitation
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
